import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICardProductPromag, IProduct } from '@shared/components/card/card-product-promag/card-product-promag.interface';
import { BaseService } from '@services/base-service.service';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ModalDetailPromagComponent } from '@shared/components/modal-detail-promag/modal-detail-promag.component';
// import { API } from '@config/constants/api.constant';
import { UtilitiesService } from '@services/utilities.service';
import { Router } from '@angular/router';
import { EnumProgramMarketingType } from '@pages/sales-marketing/program-marketing-legacy/program-marketing.enum';

@Component({
  selector: 'app-card-product-promag',
  templateUrl: './card-product-promag.component.html',
  styleUrls: ['./card-product-promag.component.scss'],
})
export class CardProductPromagComponent implements OnInit {
  @Input() isSO!: boolean;
  @Input() showView: boolean = true;
  @Output() haveProductProgramMarketing: EventEmitter<boolean> = new EventEmitter<boolean>();

  data: BehaviorSubject<ICardProductPromag[]> = new BehaviorSubject<ICardProductPromag[]>([]);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @ViewChild('modalDetail') modalDetail: ModalDetailPromagComponent;

  get dataValue() {
    return this.data.value;
  }

  set dataValue(val) {
    this.data.next(val);
  }

  constructor(
    private baseService: BaseService,
    private utils: UtilitiesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.handleDataEmit();
  }

  handleDataEmit() {
    this.data.subscribe((items) => {
      const _filter = items.find((value) => !!value.product_list?.length);
      this.haveProductProgramMarketing.emit(!!_filter);
    });
  }

  async handleDetail(value: ICardProductPromag) {
    // this.baseService.getData(API.PROGRAM_MARKETING.DETAIL_MODAL_PROGRAM + value.program_marketing_id).subscribe((resp: any) => {
    //   if (resp && resp.success) {
    //     return this.modalDetail.openModal(resp.data, value.program_marketing_name);
    //   }
    // });
    if (!value) return;
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/sales-marketing/program-marketing/', value.program_marketing_id], {
        queryParams: {
          type: EnumProgramMarketingType.ONE_SHOOT,
        },
      })
    );
    window.open(url, '_blank');
  }

  checkProductList(item: IProduct[]) {
    if (item.length <= 0) {
      return false;
    } else {
      const filter = item.find((value) => value.qty_outstanding <= 0);
      return !filter;
    }
  }

  handleNoImage = (e: Event) => this.utils.setDefaultImageProduct(e);

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
